module.exports = __webpack_public_path__ + "img/legendary-name.37e4f601.png";